import { computed } from "vue";
import DraggerMenuState from "@/stores/DraggerMenuState";
import type { PhotoMarkerShape, PhotoMarkerMode } from "@/drawing";

const SHAPE_ICONS: Record<PhotoMarkerShape, string> = {
  circle: "number-circle-one",
  thin_arrow: "arrow-up-right",
  large_arrow: "arrow-fat-up",
  text_only: "number-one",
};

const MODE_ICONS: Record<PhotoMarkerMode, string> = {
  entity: "bounding-box",
  insert: "box",
};

export function usePhotoMarkerShape() {
  const favoriteMarkers = computed<PhotoMarkerShape[]>(() =>
    DraggerMenuState.getFavoritePhotoMarkers()
  );

  const hasMultipleMarkers = computed(() => favoriteMarkers.value.length > 1);

  const currentMarkerIcon = computed(() => {
    const shape = DraggerMenuState.activePhotoMarkerShape;
    const icon = SHAPE_ICONS[shape] ?? "arrow-up-right";
    return `${icon}`;
  });

  const currentMode = computed<PhotoMarkerMode>(() =>
    DraggerMenuState.getPhotoMarkerMode()
  );

  const currentModeIcon = computed(() => {
    const icon = MODE_ICONS[currentMode.value] ?? "bounding-box";
    return `${icon}`;
  });

  function toggleShape() {
    const markers = favoriteMarkers.value;
    if (markers.length <= 1) return;

    const currentShape = DraggerMenuState.activePhotoMarkerShape;
    const currentIndex = markers.indexOf(currentShape);
    const nextIndex = (currentIndex + 1) % markers.length;
    const nextMarker = markers[nextIndex];

    DraggerMenuState.setPhotoMarkerShapeFromFavorite(nextMarker);
  }

  function toggleMode() {
    const newMode: PhotoMarkerMode =
      currentMode.value === "entity" ? "insert" : "entity";
    DraggerMenuState.setPhotoMarkerMode(newMode);
  }

  return {
    favoriteMarkers,
    hasMultipleMarkers,
    currentMarkerIcon,
    currentMode,
    currentModeIcon,
    toggleShape,
    toggleMode,
  };
}
